import OtherProjects from './OtherProjects'

export default OtherProjects
